
// ios 使用原生方法最低版本
const iosNativeVersion = {
    chooseFileHttpUpload: '1.0.5',
};
const JYExternalNative = {
    $callMobile: function (handlerInterface, handlerMethod, parameters) {
        // handlerInterface由iOS addScriptMessageHandler与andorid addJavascriptInterface 代码注入而来。
        const dic = { handlerInterface: handlerInterface, function: handlerMethod, parameters: parameters };
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            window.webkit.messageHandlers[handlerInterface].postMessage(dic);
        } else {
            // 安卓传输不了js json对象
            // eslint-disable-next-line no-lonely-if
            if (typeof window[handlerInterface][handlerMethod] === 'function') {
                if (parameters !== '' && parameters !== null && typeof parameters !== 'undefined') {
                    window[handlerInterface][handlerMethod](JSON.stringify(dic));
                } else {
                    window[handlerInterface][handlerMethod]();
                }
            }
        }
    },
    // 判断是否能使用原生方法 ios通过版本号判断
    $canUse: function (handlerMethod) {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            return Boolean(window.appVersion && window.appVersion.version >= iosNativeVersion[handlerMethod]);
        }
        return Boolean(window.JYExternalNative && window.JYExternalNative[handlerMethod]);
    },
    /**
     * 原生 拍照/相册、录制视频 返回base64数据
     * @param opt 配置参数
     * @param callback 传参默认回调模式，不传需要 await 方式接收返回参数
     * @returns {Promise<unknown>}
     */
    $chooseMediaFile: function (opt, callback) {
        // opt 配置参数说明
        // const opt = {
        //     maxNum: 3, // 最大上传个数
        //     fileType: 1, // 文件类型：0全部，1图片，2，视频
        //     albumSelection: true, //  true从相册选择，false直接拍照or录像
        //     showCameraBtn: true, // 相册选择是否展示 拍照按钮
        //     videoMaxSecond: 15, // 录像or选视频 最大秒数
        //     addWatermarkType: 2, // 加水印，0或null不加，1仅拍照、录像加，2拍照、录像、相册选择的都加
        //     watermarkInfo: {
        //         otherInfo: '666666666', // 水印文字信息
        //         time: 'yyyy-MM-dd HH:mm:ss', // 水印时间
        //         address: true, // 水印是否显示水印地址
        //         coordinate: true,// 水印是否显示经纬度
        //     }
        // };
        return new Promise((resolve, reject) => {
            try {
                this.$callMobile('JYExternalNative', 'chooseMediaFile', opt);
                if (!callback) {
                    callback = res => {
                        resolve(res);
                    };
                } else {
                    resolve();
                }
                window.callback_PhotoUpload = callback; // 图片回调
                window.callback_VideoUpload = callback; // 视频回调
                window.callback_MediaFileUpload = callback; // 全部回调
            } catch (e) {
                reject(e);
            }
        });
    },
    /**
     * 原生 拍照/相册、录制视频 网络上传，返回上传接口返回数据
     * @param opt 配置参数
     * @returns {Promise<unknown>}
     */
    $chooseFileHttpUpload: function (opt) {
        // opt 配置参数说明
        // const opt = {
        //     maxNum: 3, // 最大上传个数
        //     fileType: 1, // 文件类型：0全部，1图片，2，视频
        //     albumSelection: true, //  true从相册选择，false直接拍照or录像
        //     showCameraBtn: true, // 相册选择是否展示 拍照按钮
        //     videoMaxSecond: 15, // 录像or选视频 最大秒数
        //     addWatermarkType: 2, // 加水印，0或null不加，1仅拍照、录像加，2拍照、录像、相册选择的都加
        //     watermarkInfo: {
        //         otherInfo: '666666666', // 水印文字信息
        //         time: 'yyyy-MM-dd HH:mm:ss', // 水印时间
        //         address: true, // 水印是否显示水印地址
        //         coordinate: true,// 水印是否显示经纬度
        //         color:'#D9D1C0', // 水印颜色
        //     },
        //     oss: {
        //         key: '',// 上传路径
        //         token: {
        //             accessid: "",
        //             policy: "",
        //             signature: "",
        //             dir: "",
        //             host: "",
        //             expire: "",
        //             callback: "",
        //             bucket: ""
        //     },
        //     },
        // };
        return new Promise((resolve, reject) => {
            try {
                this.$callMobile('JYExternalNative', 'chooseFileHttpUpload', opt);
                const callback = res => {
                    resolve(res);
                };
                window.callback_HttpFileUpload = callback; // 回调
            } catch (e) {
                reject(e);
            }
        });
    },
};
export default JYExternalNative;
